import { FormErrors, useForm as mantineUseForm } from '@mantine/form';

interface FormOptions<T> {
  initialValues: T;
  validate?: (values: T) => FormErrors;
  validateInputOnBlur?: boolean;
  validateInputOnChange?: boolean;
}

export const useFormWithNameInputProp = <T>(options: FormOptions<T>) => {
  const form = mantineUseForm({ ...options });

  // Wrap the original getInputProps to always include the `name` prop
  const getInputProps = (name, inputProps = {}) => {
    return {
      name,
      ...form.getInputProps(name, inputProps),
    };
  };

  return {
    ...form,
    getInputProps,
  };
};
